import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    creditAppliedModalContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: '24px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: '20px',
      },
    },
    creditAppliedModalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      flex: 1,
    },
    creditAppliedModalTitle: {
      color: '#1A1919',
      fontSize: '36px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '40px',
      margin: '-10px 0px 0px 0px',
      padding: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: '28px',
        lineHeight: '32px',
      },
    },
    creditAppliedModalDescription: {
      color: '#505050',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    creditAppliedModalImageContainer: {
      width: '120px',
      height: '120px',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    creditAppliedModalImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  }),
  { name: 'CreditAppliedModal' },
);

export const getModalStyles = (breakpointMdDown) => ({
  container: {
    padding: '15px 15px 0px 15px',
  },
  content: {
    padding: breakpointMdDown ? '20px' : '40px 40px 48px 40px',
    maxWidth: breakpointMdDown ? '100%' : '640px',
    borderRadius: '24px',
    background: '#FFF',
    boxShadow: '0 4px 6.1px 0 rgba(174, 174, 174, 0.25)',
  },
});

export default useStyles;
